var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-3",class:("bg-" + _vm.theme + " text-" + _vm.textVariant)},[_c('h5',{staticClass:"font-weight-light m-0"},[_c('icon',{attrs:{"name":_vm.icon}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }